<template>
  <div>
    <transition-group :name="transition" tag="div">
      <application-tab
        v-if="showApplicationSelectionTab && !$store.state.errorPage"
        :key="1"
      />
      <nuxt class="container" :key="2" />
    </transition-group>
  </div>
</template>

<script>
import '@/plugins/global-css'
import ApplicationTab from '~/components/ApplicationTab'

export default {
  components: {
    ApplicationTab
  },
  data() {
    return {
      showApplicationSelectionTab: false,
      accessTokenIntervalTime: 2000,
      checkAccessTokenInterval: null
    }
  },
  computed: {
    transition() {
      // TODO: On desktop we should turn this off by returning an empty string
      // return this.$store.state.pageBackNavigation ? 'page' : 'pageleft'
      return ''
    },
    htmlClasses() {
      const arr = ['aaltra--layout']
      if (this.hasKeyboard) {
        arr.push('has-keyboard')
      }
      if (this.hasFooter) {
        arr.push('has-footer')
      }
      if (this.hasNavigation()) {
        arr.push('has-navigation')
      }
      if (this.hasNotification) {
        arr.push('has-notification')
      }
      return arr.join(' ')
    },
    hasKeyboard() {
      return this.$store.state.components.hasKeyboard
    },
    hasFooter() {
      return this.$store.state.components.hasFooter
    },
    hasNotification() {
      return this.$store.state.components.hasNotification
    },
    hasMonitoring() {
      return this.$store.state.storage.hasMonitoring
    }
  },
  watch: {
    hasMonitoring() {
      this.setShowApplicationSelectionTab()
    },
    $route() {
      this.setShowApplicationSelectionTab()
      // this.resetAccessTokenInterval()
    }
  },
  created() {
    this.$store.commit('setGigyaProfileFromStorage')
    this.setShowApplicationSelectionTab()
  },
  methods: {
    hasNavigation() {
      const navigationRefs = document.getElementsByClassName('navigation')
        ?.length
      const hasNavigation = this.$store.state.components.hasNavigation
      if (navigationRefs >= 1 && !hasNavigation) {
        this.$store.commit('components/setHasNavigation', true)
      }
      return this.$store.state.components.hasNavigation
    },
    setShowApplicationSelectionTab() {
      if (
        !!this.$storage.getUniversal('gigyaProfile') &&
        (this.$route.name === 'overview' || this.$route.name === 'energy') &&
        !!this.$storage.getUniversal('hasMonitoring') &&
        !this.$nuxt.nuxt.err &&
        !this.$store.state.errorPage
      ) {
        this.showApplicationSelectionTab = true
      } else {
        this.showApplicationSelectionTab = false
      }
    }
  },
  head() {
    return {
      htmlAttrs: {
        class: this.htmlClasses
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import (reference) '~@/assets/less/main.less';

.container {
  padding-bottom: @space-xl;
  min-height: 100vh;
}
</style>

<style lang="less">
@import (reference) '~@/assets/less/main.less';

html.has-footer {
  padding-bottom: @footer-height;

  .container {
    padding-bottom: 0;
    min-height: ~'calc(100vh - @{footer-height})';
  }

  &.has-notification {
    .container {
      // min-height: ~'calc(100vh - @{footer-height} - @{notification-size})';
    }
  }
}
</style>
